<template>
  <div>
    <div v-if="!isBusy" class="d-flex flex-column flex-md-row">
      <!-- Present   /-->
      <TeacherAttendanceCountCard
        title="Present"
        :count="counts.presentCount"
        @card-clicked="goToPresent"
        class="mr-6 mb-5 mb-lg-0"
      ></TeacherAttendanceCountCard>
      <!-- Present   /-->

      <!-- Absent   /-->
      <TeacherAttendanceCountCard
        title="Absent"
        :count="counts.absentCount"
        @card-clicked="goToAbsent"
        class="mr-6 mb-5 mb-lg-0"
      ></TeacherAttendanceCountCard>
      <!-- Absent   /-->

      <!-- Leave   /-->
      <TeacherAttendanceCountCard
        title="Leave"
        :count="counts.leaveCount"
        @card-clicked="goToLeave"
        class="mr-6 mb-5 mb-lg-0"
      ></TeacherAttendanceCountCard>
      <!-- Leave   /-->

      <!-- Away   /-->
      <TeacherAttendanceCountCard
        title="Away"
        :count="counts.awayCount"
        @card-clicked="goToAway"
        class="mr-6"
      ></TeacherAttendanceCountCard>
      <!-- Away   /-->
    </div>
    <AppLoader v-else></AppLoader>
    <TeacherAttendanceDashboardModal
      :title="title"
      :att-status-id="id"
    ></TeacherAttendanceDashboardModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TeacherAttendanceCountCard from "@/modules/dashboard/components/attendance/teacher/TeacherAttendanceCountCard";
import TeacherAttendanceDashboardModal from "@/modules/dashboard/components/attendance/teacher/TeacherAttendanceDashboardModal";
import AppLoader from "@/modules/core/components/loaders/AppLoader";

export default {
  name: "TeacherAttendanceCountDashboard",
  components: {
    AppLoader,
    TeacherAttendanceDashboardModal,
    TeacherAttendanceCountCard,
  },
  data() {
    return {
      isBusy: false,
      title: "Title",
      id: 0,
    };
  },
  mounted() {
    this.isBusy = true;
    this.$store.dispatch("fetchTeacherDashboardCount");
    this.$store
      .dispatch("fetchTeacherDashboardDailyAttendanceCount")
      .finally(() => (this.isBusy = false));
  },
  methods: {
    fetch() {
      this.isBusy = true;
      this.$store.commit("setTeacherDashboardDailyAttendancePage", 1);
      this.$store
        .dispatch("fetchTeacherDashboardDailyAttendanceList", {
          id: this.id,
        })
        .finally(() => (this.isBusy = false));
    },

    goToPresent() {
      this.title = "Teacher Present Daily Attendance List";
      this.id = 1;
      this.fetch();

      this.$bvModal.show("common-employee-details-modal");
    },

    goToAbsent() {
      this.title = "Teacher Absent Daily Attendance List";
      this.id = 2;
      this.fetch();

      this.$bvModal.show("common-employee-details-modal");
    },

    goToLeave() {
      this.title = "Teacher Leave Daily Attendance List";
      this.id = 3;
      this.fetch();

      this.$bvModal.show("common-employee-details-modal");
    },

    goToAway() {
      this.title = "Teacher Away Daily Attendance List";
      this.id = 4;
      this.fetch();

      this.$bvModal.show("common-employee-details-modal");
    },
  },
  computed: {
    ...mapGetters({
      counts: "getTeacherDashboardDailyAttendanceCount",
    }),
  },
};
</script>

<style scoped></style>
